import styled from "styled-components";
import { SKY_BLUE, WHITE, GRAY, RUBIK } from "../../index.style.ts";

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 360px;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 5px 10px ${GRAY};
  background: ${WHITE};

  h2 {
    margin: 0;
    font-family: ${RUBIK};
  }

  label {
    min-width: auto;
    text-align: left;
  }

  .toggle {
    background: none;
    border: none;
    color: ${SKY_BLUE};
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    text-align: left;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ErrorText = styled.p`
  margin: 0;
  color: #ef5350;
  font-size: 14px;
`;
